import FormSection from 'components/shared/FormSection/index';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import CouponInformation from 'pages/Coupon/components/add/CouponInformation';
import CouponPromotional from 'pages/Coupon/components/add/CouponPromotional';
import FormStatus from 'components/shared/FormCommon/FormStatus';
import CouponRsError from 'pages/Coupon/components/add/CouponRsError';
import CouponCustomerType from 'pages/Coupon/components/add/CouponCustomerType';
import Products from 'pages/Coupon/components/add/Products';

import { useForm, FormProvider } from 'react-hook-form';
import { KEY_FORM_COUPON, TYPO_TITLE_FORM } from 'pages/Coupon/utils/constants';
import { createCouponService, getDetaiCouponService, updateCouponService } from 'services/coupon.service';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const CouponAddPage = ({ noActions }) => {
  const methods = useForm();
  const { pathname } = useLocation();
  const { coupon_id } = useParams();
  const disabled = useMemo(() => pathname.includes('/detail'), [pathname]);
  const detailForm = [
    {
      id: KEY_FORM_COUPON.INFORMATION,
      title: TYPO_TITLE_FORM.INFORMATION,
      component: CouponInformation,
      fieldActive: ['coupon_name', 'budget', 'total_coupon_value', 'start_date', 'end_date'],
    },
    {
      id: KEY_FORM_COUPON.COUPON_VALUE,
      title: TYPO_TITLE_FORM.COUPON_VALUE,
      component: CouponPromotional,
    },
    {
      id: KEY_FORM_COUPON.COUPON_PRODUCT,
      title: TYPO_TITLE_FORM.COUPON_PRODUCT,
      component: Products,
      fieldActive: ['products'],
    },
    {
      id: KEY_FORM_COUPON.ERROR_APPLY,
      title: TYPO_TITLE_FORM.ERROR_APPLY,
      component: CouponRsError,
    },
    {
      id: KEY_FORM_COUPON.CUSTOMER_TYPE_APPLY,
      title: TYPO_TITLE_FORM.CUSTOMER_TYPE_APPLY,
      component: CouponCustomerType,
    },
    {
      id: KEY_FORM_COUPON.COUPON_STATUS,
      title: TYPO_TITLE_FORM.COUPON_STATUS,
      hiddenSystem: true,
      component: FormStatus,
    },
  ];
  const onSubmit = async (payload) => {
    try {
      payload.error_list = (payload?.error_list ?? [])?.map((e) => e?.error_id);
      payload.request_type_list = (payload?.request_type_list ?? [])?.map((e) => e?.value ?? e?.id);
      payload.customer_type_list = (payload?.customer_type_list ?? [])?.map((e) => e?.customer_type_id);

      let label;
      if (coupon_id) {
        await updateCouponService({ coupon_id: coupon_id, ...payload });
        label = 'Chỉnh sửa';
      } else {
        await createCouponService(payload);
        label = 'Thêm mới';
        methods.reset({
          is_active: 1,
        });
      }
      toast.success(`${label} thành công`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    } catch (error) {
      toast.error(error?.message ?? 'Có lỗi xảy ra', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: true,
        theme: 'colored',
      });
    } finally {
    }
  };

  const loadCouponDetail = useCallback(() => {
    if (coupon_id) {
      getDetaiCouponService(coupon_id).then((value) => {
        methods.reset({
          ...value,
          request_type_list: value?.request_type_list?.map((e) => {
            return {
              value: e?.request_type_id,
              label: e?.request_type_name,
            };
          }),
        });
      });
    } else {
      methods.reset({
        is_active: 1,
        is_all_customer_type: 1,
      });
    }
  }, [coupon_id]);

  useEffect(loadCouponDetail, [loadCouponDetail]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <FormSection noActions={noActions} detailForm={detailForm} onSubmit={onSubmit} disabled={disabled} />
      </FormProvider>
    </React.Fragment>
  );
};

export default CouponAddPage;
